import { DrawerBody, DrawerHeader } from "@chakra-ui/modal";
// import AtriumApi from "api";
// import DarkButton from "components/actions/DarkButton";
// import GrayButton from "components/actions/GrayButton";
import Avatar from "components/avatar";
// import Dialog from "components/dialog";
// import PenEditIcon from "components/icons/PenEditIcon";
// import PlusIcon from "components/icons/PlusIcon";
import { useEffect, useState } from "react";
// import CloseIcon from "components/icons/CloseIcon";
// import AlertPane from "components/alert";
// import TrashIcon from "components/icons/TrashIcon";
// import EditableSelect from "components/fields/EditableSelect";
import Details from "./tabs/details";
import HouseHold from "./tabs/houseHold";
import History from "./tabs/history";
import Groups from "./tabs/groups";
import { useParams } from "react-router-dom";
import AtriumApi from "api";
import Demographic from "./tabs/Demographic";

// const Details = ({user, setReadonly}) => {
//     return <>
//         <div className="flex py-6 border-b">
//             <div className="text-left text-base text-gray-700">Contact email</div>
//             <div className="text-right text-base flex-1">{user.email}</div>
//         </div>

//         <div className="flex py-6 border-b">
//             <div className="text-left text-base text-gray-700">Contact phone</div>
//             <div className="text-right text-base flex-1">{user.phone}</div>
//         </div>

//         <div className="flex py-6 border-b">
//             <div className="text-left text-base text-gray-700">Gender</div>
//             <div className="text-right text-base flex-1">{{na: "Prefer not to tell", other: "Non-binary"}[user.gender] || <span className="capitalize">{user.gender}</span>}</div>
//         </div>

//         <div className="flex py-6 border-b">
//             <div className="text-left text-base text-gray-700">Location</div>
//             <div className="text-right text-base flex-1">
//                 {user.address && <>{user.address}<br/></>}
//                 {user.city && `${user.city}, `}{user.state && user.state} {user.zip && user.zip}{(user.city || user.state || user.zip) && <br/>}
//                 {user.country}
//             </div>
//         </div>

//         <div className="flex py-6 border-b">
//             <div className="text-left text-base text-gray-700">Age</div>
//             <div className="text-right text-base flex-1">{new Date().getUTCFullYear() - new Date(user.dob).getUTCFullYear()}</div>
//         </div>

//         <div className="flex py-6 border-b">
//             <div className="text-left text-base text-gray-700">Family relationship</div>
//             <div className="text-right text-base flex-1 capitalize">{user.familyRelationship}</div>
//         </div>

//         <div className="flex py-6">
//             <DarkButton onClick={() => setReadonly(false)}>
//                 <PenEditIcon/>
//                 Edit profile
//             </DarkButton>
//         </div>
//     </>
// }

// const Household = ({user, setUser}) => {
//     const [showForm, setShowForm] = useState()
//     const [inputValue, setInputValue] = useState("");
//     const [household, setHousehold] = useState();
//     const [households, setHouseholds] = useState([])
//     const [queryOptions, setQueryOptions] = useState({per: 10});
//     const [members, setMembers] = useState([user])
//     const [error, setError] = useState("")

//     const onInputChange = (inputValue, { action }) => {
//         if (action === "input-change") {
//           setInputValue(inputValue)
//           setHousehold(null)
//         }
//     }

//     const onChange = (option) => {
//         if (!option && household?.value) {
//             setMembers([user])
//         } else if (option && option.value !== household?.value) {
//             if (option.origin.users.find(u => u.id === user.id)) {
//                 setMembers(option.origin.users)
//             } else {
//                 setMembers([...option.origin.users, user])
//             }
//         }
//         setHousehold(option);
//         setInputValue(option ? option.label : "");
//     }

//     const saveHousehold = () => {
//         setError("")
//         if (!inputValue) {
//             setError("Please enter name of householder")
//             return;
//         }

//         if (!members.length) {
//             setError("Please select household members")
//             return;
//         }

//         if (household) {
//             const payload = {
//                 memberIds: members.map(o => o.id)
//             }
//             AtriumApi.put(`households/${household.id}`, payload).then((resp) => {
//                 setShowForm(false)
//             })
//         } else {
//             const payload = {
//                 name: inputValue,
//                 memberIds: members.map(o => o.id)
//             }
//             AtriumApi.post("households", payload).then((resp) => {
//                 setShowForm(false)
//             })
//         }
//     }

//     const searchHousehold = (query, callback) => {
//         AtriumApi.get("households", {params: { q: query }})
//         .then((response) => {
//             callback(response.data.households.map(household => {
//                 return {
//                     label: household.name,
//                     value: household.id,
//                     origin: household
//                 }
//             }))
//         })
//     }

//     const searchPeople = (query, callback) => {
//         AtriumApi.get("users", { params: queryOptions })
//         .then((response) => {
//             callback(response.data.users.map(user => {
//                 return {
//                     label: `${user.firstName} ${user.lastName}`,
//                     value: user.id,
//                     origin: user
//                 }
//             }))
//         })
//     }

//     const addPerson = (option) => {
//         if (members.findIndex(o => o.id === option.origin.id) !== -1) return;
//         setMembers([...members, option.origin])
//     }

//     const removePerson = (person) => {
//         setMembers(members.filter(o => o.id !== person.id))
//     }

//     const deleteHousehold = (householdId) => {
//         AtriumApi.delete(`households/${householdId}`)
//         .then(() => {
//             setHouseholds(households.filter(h => h.id !== householdId))
//         })
//     }

//     // useEffect(() => {
//     //     if (showForm) return;
//     //     AtriumApi.get("households", { params: { uid: user.id } } )
//     //     .then((response) => {
//     //         setHouseholds(response.data.households)
//     //     })
//     // }, [showForm])

//     return <>
//         <Dialog isOpen={showForm} onClose={() => (setInputValue(''), setShowForm(false))} cancelCloseByOverlay={true}>
//             <div className="text-lg font-bold dark:text-white">Manage Households</div>

//             {error && <div className="pt-3"><AlertPane state="error">{error}</AlertPane></div>}

//             <EditableSelect
//             className="my-6"
//             loadOptions={searchHousehold}
//             // isClearable={true}
//             value={household}
//             inputValue={inputValue}
//             onInputChange={onInputChange}
//             onChange={onChange}
//             controlShouldRenderValue={false}
//             placeholder="Household"
//             noOptionsMessage={ ({inputValue}) => inputValue || "No Household" }
//             />

//             <div className="pt-4">
//                 <EditableSelect
//                 placeholder="Search for people to add"
//                 noOptionsMessage={ ({inputValue}) => inputValue ? "No matches found" : "Search by first name or last name" }
//                 inputValue={queryOptions.q || ""}
//                 onInputChange={(v) => setQueryOptions({...queryOptions, q: v})}
//                 value=""
//                 onChange={addPerson}
//                 loadOptions={searchPeople}
//                 />
//             </div>

//             <div className="p-3">
//                 {members.map((member, i) => <div key={`member${i}`} className="flex flex-row items-center gap-3 my-3">
//                     <Avatar user={member} size="md"/>
//                     <div className="flex-1">
//                         <p className="text-md font-medium">{member.firstName} {member.lastName}</p>
//                         <p className="text-sm text-gray-700 font-medium capitalize">{member.role}</p>
//                     </div>
//                     <div>
//                         <a className="p-2 inline-block cursor-pointer" onClick={() => removePerson(member)}><CloseIcon/></a>
//                     </div>
//                 </div>)}
//             </div>

//             <div className="flex gap-2 mt-6">
//                 <DarkButton onClick={saveHousehold}>{household ? "Update" : "Create"}</DarkButton>
//                 {household && <DarkButton kind="danger" onClick={() => {deleteHousehold(household.value); setHousehold(null); setInputValue(""); setMembers([user])}}>Delete</DarkButton>}
//                 <GrayButton onClick={() => setShowForm(false)}>Cancel</GrayButton>
//             </div>
//         </Dialog>

//         {households.map(h => {
//             return <div key={`h${h.id}`}>
//                 <div className="flex pt-6 pb-2 border-b px-4 items-end">
//                     <div className="w-48 text-lg font-bold flex-1 cursor-pointer" onClick={() => {setHousehold({label: h.name, id: h.id, origin: h}); setMembers(h.users); setInputValue(h.name); setShowForm(true)}}>ddd</div>
//                     <a className="p-2 inline-block cursor-pointer text-red-700" onClick={() => deleteHousehold(h.id)}><TrashIcon/></a>
//                 </div>
//                 <div className="py-2 px-4">
//                     {h.users.map(member => <div key={`h${h.id}-${member.id}`} className="flex flex-row items-center py-2 gap-3">
//                         <Avatar user={member} size="md"/>
//                         <div className="flex-1">
//                             <p className="text-md font-medium">{member.firstName} {member.lastName}</p>
//                             <p className="text-sm text-gray-700 font-medium capitalize">{member.role}</p>
//                         </div>
//                     </div>)}
//                 </div>
//             </div>
//         })}

//         {/* <div className="flex pt-6 pb-2 border-b px-4">
//             <div className="w-48 text-sm text-gray-700">HOUSEHOLD</div>
//             <div className="flex-2 text-sm flex-1 text-gray-700">VALUE</div>
//         </div>

//         <div className="flex py-6 border-b px-4">
//             <div className="w-48 text-base">Spouse</div>
//             <div className="text-base flex-1 text-gray-700">Full name</div>
//         </div>

//         <div className="flex py-6 border-b px-4">
//             <div className="w-48 text-base">Child</div>
//             <div className="text-base flex-1 text-gray-700">Full name</div>
//         </div> */}

//         <div className="flex py-6">
//             <DarkButton onClick={() => {setHousehold(null); setMembers([user]); setShowForm(true)}}>
//                 Manage Households
//             </DarkButton>
//         </div>
//     </>
// }

// const History = ({user}) => {
//     return <>
//         <div className="flex pt-6 pb-2 border-b px-4">
//             <div className="w-48 text-sm text-gray-700">SERVICE</div>
//             <div className="flex-2 text-sm flex-1 text-gray-700">DATE AND TIME</div>
//         </div>

//         <div className="flex py-[18px] border-b px-4">
//             <div className="w-48 text-base">
//                 <p>Service name</p>
//                 <p className="text-gray-700">Service type</p>
//             </div>
//             <div className="text-base flex-1">
//                 <p>Oct 20, 2024</p>
//                 <p className="text-gray-700">10:00 AM - 04:00 PM</p>
//             </div>
//         </div>

//         <div className="flex py-[18px] border-b px-4">
//             <div className="w-48 text-base">
//                 <p>Service name</p>
//                 <p className="text-gray-700">Service type</p>
//             </div>
//             <div className="text-base flex-1">
//                 <p>Oct 20, 2024</p>
//                 <p className="text-gray-700">10:00 AM - 04:00 PM</p>
//             </div>
//         </div>

//         <div className="flex py-[18px] border-b px-4">
//             <div className="w-48 text-base">
//                 <p>Service name</p>
//                 <p className="text-gray-700">Service type</p>
//             </div>
//             <div className="text-base flex-1">
//                 <p>Oct 20, 2024</p>
//                 <p className="text-gray-700">10:00 AM - 04:00 PM</p>
//             </div>
//         </div>
//     </>
// }

// const Groups = ({user, setUser}) => {
//     const [groups, setGroups] = useState([])
//     const [counts, setCounts] = useState([]);
//     const [showForm, setShowForm] = useState(false);
//     const [group, setGroup] = useState("");
//     const [inputValue, setInputValue] = useState("");

//     // useEffect(() => {
//     //     AtriumApi.get("groups").then(resp => {
//     //         setGroups(resp.data.groups)
//     //         setCounts(resp.data.counts)
//     //     })
//     //     setInputValue("")
//     // }, [user])

//     const onInputChange = (inputValue, { action }) => {
//         if (action === "input-change") {
//           setInputValue(inputValue);
//         }
//     }

//     const onChange = (option) => {
//         setGroup(option);
//         setInputValue(option ? option.label : "");
//     }

//     const joinGroup = () => {
//         if (!inputValue) return;

//         AtriumApi.post("user-groups", {userId: user.id, group: inputValue}).then((resp) => {
//             setShowForm(false)
//             setUser({...user, groupIds: resp.data.groupIds})
//         })
//     }

//     const leaveGroup = (groupId) => {
//         AtriumApi.delete("user-groups", {data: {userId: user.id, groupId: groupId}}).then((resp) => {
//             setUser({...user, groupIds: resp.data.groupIds})
//         })
//     }

//     return (
//         <>
//             <Dialog isOpen={showForm} onClose={() => (setInputValue(''), setShowForm(false))} cancelCloseByOverlay={true}>
//                 <div className="text-lg font-bold dark:text-white">Select or create group to join</div>

//                 <EditableSelect
//                 className="my-6"
//                 options={groups.filter(o => (user.groupIds || []).indexOf(o.id) === -1).map(o => new Object({label: o.name, value: o.id}))}
//                 value={group}
//                 inputValue={inputValue}
//                 onInputChange={onInputChange}
//                 onChange={onChange}
//                 controlShouldRenderValue={false}
//                 placeholder="Group"
//                 noOptionsMessage={ ({inputValue}) => inputValue || "No Group" }
//                 />

//                 <div className="flex gap-2 mt-6">
//                     <DarkButton onClick={joinGroup}>Join</DarkButton>
//                     <GrayButton onClick={() => setShowForm(false)}>Cancel</GrayButton>
//                 </div>
//             </Dialog>

//             {(user.groupIds || []).map(gid => {
//                 const group = groups.find(g => g.id === gid)
//                 if (!group) return;

//                 return <div key={'user-group-' + gid} className="flex flex-row items-center py-[18px] border-b px-6">
//                     <div className="flex-1">
//                         <p className="text-base font-bold">{group.name}</p>
//                         <p className="text-sm text-gray-700">{counts.find(o => o.groupId === group.id)?.membersCount} members</p>
//                     </div>
//                     <div>
//                         <a className="p-2 inline-block cursor-pointer" onClick={() => leaveGroup(gid)}><CloseIcon/></a>
//                     </div>
//                 </div>
//             })}

//             <div className="flex py-6">
//                 <DarkButton onClick={() => {setShowForm(true)}}>
//                     <PlusIcon/> Join Group
//                 </DarkButton>
//             </div>
//         </>
//     )
// }

const UserDetails = ({ user, setUser, setReadonly }) => {
  const { id } = useParams();

  useEffect(() => {
    if (!user?.id) {
      AtriumApi.get(`/v1/users/get-user/${id}`).then((resp) => {
        setUser(resp?.data?.user);
      });
    }
  }, [id, user]);

  // const [tab, setTab] = useState("details");
  // if (!user) return;
  const tabs = [
    "Details",
    "HouseHold",
    "Demographic",
    "History",
    //  "Groups"
  ];
  const [activeTab, setActiveTab] = useState("Details");

  const renderContent = () => {
    switch (activeTab) {
      case "Details":
        return <Details user={user} />;
      case "HouseHold":
        return <HouseHold user={user} />;
      case "History":
        return <History user={user} />;
      case "Demographic":
        return <Demographic userId={user?.id || id} user={user} />;
      case "Groups":
        return <Groups />;
      default:
        return null;
    }
  };
  return (
    <>
      <DrawerHeader className="px-[32px] pt-6">
        <div className="flex gap-[15px] align-center justify-center">
          <Avatar user={user} />
          <div className="flex-1 flex content-center justify-center flex-col">
            <div className="font-bold text-xl text-gray-800 dark:text-white">
              {user?.firstName} {user?.lastName}
            </div>
            <div className="font-normal text-sm text-gray-700 mt-1">
              <span
                className={`inline-block align-middle capitalize w-fit px-2 py-1 text-xs text-brand-800 bg-green-100 dark:bg-green-50 rounded-[10px] text-base font-bold mr-2`}
              >
                {user?.role}
              </span>
              <span
                className={`inline-block align-middle capitalize w-fit px-2 py-1 text-xs ${
                  user?.status === "active"
                    ? "text-brand-800 bg-green-100 dark:bg-green-50"
                    : "text-red-500 bg-red-100 dark:bg-red-50"
                } rounded-[10px] text-base font-bold`}
              >
                {user?.status}
              </span>
            </div>
          </div>
        </div>
      </DrawerHeader>
      <DrawerBody className="flex-1 px-[32px] my-6 dark:text-white overflow-auto">
        {/* <div className="flex gap-1 rounded-2xl bg-gray-50 dark:bg-navy-700 p-1 mb-[8px]">
                    <button className={`inline-block px-4 py-2 font-bold rounded-2xl ${tab === 'details' ? "bg-white text-gray-800 dark:bg-background-900 dark:text-white" : "bg-none text-gray-700 dark:text-gray-600"}`} onClick={() => setTab('details')}>Details</button>
                    <button className={`inline-block px-4 py-2 font-bold rounded-2xl ${tab === 'household' ? "bg-white text-gray-800 dark:bg-background-900 dark:text-white" : "bg-none text-gray-700 dark:text-gray-600"}`} onClick={() => setTab('household')}>Household</button>
                    <button className={`inline-block px-4 py-2 font-bold rounded-2xl ${tab === 'history' ? "bg-white text-gray-800 dark:bg-background-900 dark:text-white" : "bg-none text-gray-700 dark:text-gray-600"}`} onClick={() => setTab('history')}>History</button>
                    <button className={`inline-block px-4 py-2 font-bold rounded-2xl ${tab === 'groups' ? "bg-white text-gray-800 dark:bg-background-900 dark:text-white" : "bg-none text-gray-700 dark:text-gray-600"}`} onClick={() => setTab('groups')}>Groups</button>
                </div>
                
                {tab === 'details' && <Details user={user} setReadonly={setReadonly}/>}
                {tab === 'household' && <Household user={user}/>}
                {tab === 'history' && <History user={user}/>}
                {tab === 'groups' && <Groups user={user} setUser={setUser}/>} */}
        {/* <div className="flex gap-1 rounded-2xl bg-gray-50 dark:bg-navy-700 p-1 mb-[8px]"> */}
        {/* <Details/>
                    <HouseHold/> */}
        <div>
          {/* Tabs */}
          <div className="flex overflow-auto rounded-[16px] border-gray-300 bg-[#F4F7FE] dark:bg-navy-900 py-1 px-2 mb-4">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-3 text-sm font-medium  ${
                  activeTab === tab
                    ? "text-[#2B3674] bg-white rounded-[16px]"
                    : "text-[#707EAE] "
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div>{renderContent()}</div>
        </div>
        {/* </div> */}
      </DrawerBody>
    </>
  );
};

export default UserDetails;
